import { createContext, useContext, useMemo } from 'react'
import { CalendarDataFragment } from '../generated/graphql'

export type ToggleCalendarSelection = (calendarId: any) => void
export type CalendarSelection = Record<string, boolean | undefined>

export interface SelectableCalendar extends CalendarDataFragment {
  isSelected: boolean
}

export const SelectedCalendarsContext = createContext<SelectableCalendar[]>([])
export const CalendarDispatchContext = createContext<ToggleCalendarSelection | undefined>(undefined)

export function useCalendars() {
  return {
    calendars: useCalendarsList(),
    selectedCalendars: useSelectedCalendars(),
    toggleSelectedCalendar: useToggleSelectedCalendar(),
  }
}

export function useCalendarsList(): SelectableCalendar[] {
  return useContext(SelectedCalendarsContext)
}

export function useSelectedCalendars(): SelectableCalendar[] {
  const calendars = useContext(SelectedCalendarsContext)
  return useMemo(() => calendars.filter((calendar) => calendar.isSelected), [calendars])
}

export function useToggleSelectedCalendar(): ToggleCalendarSelection {
  const context = useContext(CalendarDispatchContext)
  if (!context) {
    throw new Error('"useToggleSelectedCalendar()" must be used within a "CalendarProvider"')
  }
  return context
}
